exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".styles_logout__23XUQ {\n  position: absolute;\n  right: 25px;\n  z-index: 1; }\n", ""]);

// Exports
exports.locals = {
	"logout": "styles_logout__23XUQ"
};